/**
 * Lead Source Grouping
 *
 * Regrupuje kubełki źródeł leadów (z dashboard-source-breakdown.ts) do chipów kafelka LEADY:
 * paid platforms osobno (meta / google / tiktok), wszystkie rozpoznane źródła nie-płatne w jeden
 * `organic`, a `unattributed` zostaje osobnym chipem `Nieprzypisane`. Suma chipów == suma leadów
 * wejściowych (reconciliacja zachowana). Pure — unit-testowalne.
 */

export type LeadSourceBucket = { key: string; label: string; leads: number };
export type LeadChip = { label: string; value: number };

const TIKTOK_LEAD_SOURCES = new Set(["src_tiktok", "src_tt"]);
const ORGANIC_LABEL = "organic";
const UNATTRIBUTED_LABEL = "Nieprzypisane";

const classify = (key: string): "meta" | "google" | "tiktok" | "organic" | "unattributed" => {
  if (key === "meta_paid") return "meta";
  if (key === "google_paid") return "google";
  if (TIKTOK_LEAD_SOURCES.has(key)) return "tiktok";
  if (key === "unattributed") return "unattributed";
  return "organic";
};

export function groupLeadSourceBuckets(buckets: LeadSourceBucket[]): LeadChip[] {
  const acc: Record<string, number> = {
    meta: 0,
    google: 0,
    tiktok: 0,
    organic: 0,
    unattributed: 0,
  };
  for (const b of buckets || []) {
    acc[classify(b.key)] += b.leads || 0;
  }
  const ordered: Array<[string, number]> = [
    ["meta", acc.meta],
    ["google", acc.google],
    ["tiktok", acc.tiktok],
    [ORGANIC_LABEL, acc.organic],
    [UNATTRIBUTED_LABEL, acc.unattributed],
  ];
  return ordered.filter(([, v]) => v > 0).map(([label, value]) => ({ label, value }));
}
